import isFunction from "lodash/isFunction";
import isNil from "lodash/isNil";
import LoanFilePreview from "../../screens/LoanDrilldownScreen/tabs/LoanDrilldownFilesTab/LoanFilePreview";
import SideCardModal from "./SideCardModal";
/**
 * Usage:
   const [file, setFile] = useState(null);
   <FilePreviewSideModal file={file} onClose={() => setFile(null)} />
 */
const FilePreviewSideModal = ({ file, onClose }) => {
  const handleClose = () => {
    if (isFunction(onClose)) {
      onClose(null);
    }
  };
  return (
    <SideCardModal
      title={file?.file_display_name || "File Preview"}
      show={!isNil(file)}
      onClose={handleClose}
      suppressBodyPadding
    >
      <LoanFilePreview
        fileObject={file}
        containerId={file?.containerName}
        sx={{ overflowY: "auto" }}
      />
    </SideCardModal>
  );
};

export default FilePreviewSideModal;
